import { render, staticRenderFns } from "./ContextSelectorWithPrefix.vue?vue&type=template&id=136a96ba&scoped=true&"
import script from "./ContextSelectorWithPrefix.vue?vue&type=script&lang=js&"
export * from "./ContextSelectorWithPrefix.vue?vue&type=script&lang=js&"
import style0 from "./ContextSelectorWithPrefix.vue?vue&type=style&index=0&id=136a96ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a96ba",
  null
  
)

export default component.exports